import React, { useEffect, useRef, useState } from "react";
import { TextInput } from "../input/TextInput";
import SVGraphics from "../../assets/SVGraphics";
import { useNavigate } from "react-router-dom";
import { authenticationService } from "../../services/AuthinticationService";
import AppLogout from "../../view/auth/AppLogout";

import device_management from "../../assets/device_management.svg";
import device_managementSelected from "../../assets/device_managementSelected.svg";

export function SideNavigationBar(props) {
  const { logoutUser, rolePath, NavTypes, handleClick } = props;
  const [navType, setNavType] = useState(
    `${rolePath === "User" ? "" : "Dashboard"}`
  );
  const [currentUser, setCurrentUser] = useState();
  const [userInfo, setUserInfo] = useState();
  const [show, setShow] = useState(false);
  const target = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const user = authenticationService.currentUserValue.profile;
    setUserInfo(user);
  }, []);

  useEffect(() => {
    const path = window.location.pathname;
    const segments = path.split("/").filter(Boolean);
    const lastSegment = segments.pop();
    if (lastSegment === rolePath) {
      setNavType(`${rolePath === "User" ? "" : "Dashboard"}`);
    }
  }, [window.location.pathname, rolePath]);

  useEffect(() => {
    authenticationService.currentUser.subscribe((currentUser) =>
      setCurrentUser(currentUser)
    );
    const pathname = window.location.pathname;
    setNavHandler(pathname);
  }, [window.location.pathname]);

  window.addEventListener("popstate", function (event) {
    const pathname = window.location.pathname;
    setNavHandler(pathname);
  });

  const setNavHandler = (pathname) => {
    if (pathname.includes("Dashboard")) {
      setNavType("Dashboard");
    } else if (pathname.includes("Sites")) {
      setNavType("Sites");
    } else if (pathname.includes("Users")) {
      setNavType("Users");
    } else {
      setNavType("");
    }
  };

  const setType = (type) => {
    switch (type) {
      case "Dashboard":
        setNavType(type);
        navigate(`/${props.rolePath}/Dashboard`, { state: { NavType: 1 } });
        break;
      case "Users":
        setNavType(type);
        navigate(`/${props.rolePath}/Users`, { state: { NavType: 3 } });
        break;
      case "Sites":
        setNavType(type);
        navigate(`/${props.rolePath}/Sites`, { state: { NavType: 2 } });
        break;
      case "Settings":
        // popup only – do NOT change navType so no highlight
        props.onSettingsClick && props.onSettingsClick();
        break;
      case "Account":
        // popup only – do NOT change navType so no highlight
        props.onAccountClick && props.onAccountClick();
        break;
      default:
        setNavType(type);
        navigate(`/${props.rolePath}/Dashboard`, { state: { NavType: 1 } });
        break;
    }
  };

  return (
    <AppLogout>
      <div className=" bg-[#111111] shadow-lg h-[100%] box-border border-r-[#2D2D2D] border-r-[1px]">
        <ul className="flex flex-col pt-1 min-h-[668px] w-60">
          {NavTypes?.map((type, index) => {
            let navTypeSelected = navType === type.name;
            let isPhoto = type.isPhoto;

            // If this is “Settings” and the user is SuperAdmin, first output a divider
            if (type.name === "Settings" && rolePath === "SuperAdmin") {
              return (
                <React.Fragment key="Settings">
                  <li
                    className={`${index === 0 ? "mt-[1.5rem]" : "mt-0"} ${
                      navTypeSelected ? "bg-[#5a3eff] bg-opacity-20" : ""
                    } h-[32px] pl-[1rem] py-[8px] box-border flex items-center justify-center`}
                    onClick={() => {
                      handleClick && handleClick();
                      setType("Settings");
                    }}
                  >
                    <div className="flex items-center cursor-pointer">
                      {!isPhoto && (
                        <SVGraphics
                          className="cursor-pointer mr-[0.75rem] w-[18px] h-[18px] text-[#888888]"
                          svgname={type.svg}
                          fill="none"
                        />
                      )}
                      {isPhoto && (
                        <img
                          className="mr-[0.75rem] h-[1.5rem] w-[1.375rem] cursor-pointer"
                          src={device_management}
                          alt=""
                        />
                      )}
                      <TextInput
                        text={type.label}
                        className="w-[10.438rem] cursor-pointer text-[#888] text-[13px] leading-[1.5rem]"
                      />
                    </div>
                  </li>
                </React.Fragment>
              );
            }

            return (
              <React.Fragment key={type.name}>
                {type.name === "Account" &&
                (rolePath === "SuperAdmin" || rolePath === "Admin") ? (
                  <div className="border-t border-[#484848] my-4"></div>
                ) : null}
                <li
                  className={`${index === 0 ? "mt-[1.5rem]" : "mt-0"} ${
                    navTypeSelected ? "bg-[#5a3eff] bg-opacity-20" : ""
                  } h-[32px] pl-[1rem] py-[8px] box-border flex items-center justify-center`}
                  onClick={() => {
                    handleClick && handleClick();
                    setType(type.name);
                  }}
                >
                  <div className="flex items-center cursor-pointer">
                    {!isPhoto && (
                      <SVGraphics
                        className="cursor-pointer mr-[0.75rem] w-[18px] h-[18px] text-[#888888]"
                        svgname={type.svg}
                        fill="none"
                      />
                    )}
                    {isPhoto && (
                      <img
                        className="cursor-pointer mr-[0.75rem] h-[1.5rem] m-w-[1.375rem] w-[1.375rem]"
                        src={
                          navTypeSelected
                            ? device_managementSelected
                            : device_management
                        }
                        alt=""
                      />
                    )}
                    <TextInput
                      text={type.label}
                      className="w-[10.438rem] cursor-pointer text-[#888] text-[13px] leading-[1.5rem]"
                    />
                  </div>
                </li>
              </React.Fragment>
            );
          })}
        </ul>
      </div>
      <div className="absolute bottom-0 left-0 w-full p-3 flex flex-col gap-2">
        {/* User Info */}
        <div className="flex items-center gap-3">
          {/* Avatar */}
          <div className="w-[41px] h-[37px] rounded-[12px] bg-[#5A3EFF] text-white flex items-center justify-center font-semibold text-sm">
            {userInfo
              ? `${userInfo.First_name?.[0] ?? ""}.${
                  userInfo.Last_name?.[0] ?? ""
                }`
              : "?"}
          </div>

          {/* Email and Role */}
          <div className="flex flex-col justify-center">
            {/* Email with hover-expand */}
            <div className="relative max-w-[150px] group">
              <div className="text-sm text-white leading-tight truncate">
                {userInfo?.Email ?? "Loading..."}
              </div>

              {/* Hover popup */}
              <div
                className="
                  absolute
                  top-1/2 -translate-y-1/2
                  left-full ml-2
                  hidden group-hover:flex
                  items-center
                  bg-gray-800 text-white
                  text-xs px-2 py-1
                  rounded shadow-lg
                  whitespace-nowrap
                  z-50
                "
              >
                {userInfo?.Email}
              </div>
            </div>

            {/* Role */}
            <div className="text-xs text-white border border-white border-opacity-30 rounded-full px-3 py-[1px] w-fit mt-[2px]">
              {userInfo?.Role ?? ""}
            </div>
          </div>
        </div>

        <div
          className="flex items-center cursor-pointer"
          onClick={() => logoutUser()}
        >
          <SVGraphics
            className="cursor-pointer mr-[0.75rem] w-[18px] h-[18px] text-[#888888]"
            svgname="logout"
          />
          <TextInput
            text="Logout"
            className="cursor-pointer text-[#888] text-base font-light leading-7"
          />
        </div>
      </div>
    </AppLogout>
  );
}
